































import {Component, Mixins} from 'vue-property-decorator'
import {$, PageCollection} from 'simpli-web-sdk'
import {MixinFilter} from '@/components/mixins/MixinFilter'
import DeliveryUfRequest from '@/model/request/DeliveryUfRequest'
import FilterDeliveryUf from '@/components/filters/FilterDeliveryUf.vue'
import DeliveryUfResponse from '@/model/response/DeliveryUfResponse'
import {AppConfig} from '@/config/app.config'
import {snakeCase} from 'lodash'
import * as Helper from '@/helpers'
import FilterToggle from '@/components/FilterToggle.vue'

const metaInfo = () => ({
  title: $.t('view.reports.deliveryUf.title'),
})

@Component({
  metaInfo,
  components: {FilterToggle, FilterDeliveryUf},
})
export default class ReportsDeliveryUfView extends Mixins(MixinFilter) {
  filter = new DeliveryUfRequest()
  collection = new PageCollection(DeliveryUfResponse, this.filter, 10)

  AppConfig = AppConfig

async downloadData(xlsx: boolean) {
  if (!xlsx) {
      const csv = new PageCollection(DeliveryUfResponse, this.filter, null, null)

      const fetch = async () => await csv.search()
      await $.await.run(fetch, 'download')
      csv.downloadCsv(snakeCase($.t('view.reports.deliveryUf.title')))
  } else {
      await $.await.run(() => Helper.downloadXlsx(
        $.t('view.reports.deliveryUf.title'),
        new DeliveryUfResponse().$endpoint,
        this.filter,
        DeliveryUfResponse,
        'DeliveryUfResponse',
        ), 'download')
  }
}
}
